export default {
    'OPERACION_PUBL': (state, mutation) => {
        state.publicacion = mutation.publicacion
    }
}